import { render } from "./SidebarMenu2.vue?vue&type=template&id=6a2dd2d6&scoped=true"
import script from "./SidebarMenu2.vue?vue&type=script&lang=js"
export * from "./SidebarMenu2.vue?vue&type=script&lang=js"

import "./SidebarMenu2.vue?vue&type=style&index=0&id=6a2dd2d6&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2dd2d6"]])

export default __exports__